"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionalDataModel = void 0;
const factory_js_1 = require("./factory.js");
const translatable_error_js_1 = require("../translation/translatable-error.js");
/**
 * @internal
 */
class DimensionalDataModel {
    constructor(name, dataSource, metadata) {
        this.name = name;
        this.dataSource = dataSource;
        this.metadata = metadata;
        let key;
        for (let i = 0; i < metadata.length; i++) {
            key = metadata[i].name;
            if (this[metadata[i].name]) {
                key = `${key} (${Math.random()})`;
            }
            this[key] = metadata[i];
        }
    }
    static fromConfig(config) {
        if (config && !config.name) {
            throw new translatable_error_js_1.TranslatableError('errors.dataModel.noName');
        }
        if (config && !config.metadata) {
            throw new translatable_error_js_1.TranslatableError('errors.dataModel.noMetadata');
        }
        const metadata = new Array();
        for (let i = 0; i < config.metadata.length; i++) {
            metadata.push((0, factory_js_1.create)(config.metadata[i]));
        }
        return new DimensionalDataModel(config.name, config.dataSource, metadata);
    }
}
exports.DimensionalDataModel = DimensionalDataModel;
